import { Link } from 'react-router-dom';

export const TermsAndPolicyPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white dark:bg-gray-900 px-4 space-y-8">
      <div className="w-full max-w-2xl bg-white dark:bg-gray-800 rounded-xl overflow-hidden">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center">
              <img
                src="https://app.thenewscc.com.br/square_logo_favicon.png"
                alt="Coffee Cup"
                className="w-6 h-6"
              />
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-800 dark:text-gray-200">the news</span>
                <span className="text-sm text-gray-500">06:06</span>
              </div>
              <div className="text-sm text-gray-500">para: você@email.com</div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="text-left space-y-2">
              <h1 className="text-3xl font-bold mb-6">
                <span className="text-yellow-400">termos</span> do programa de indicação
              </h1>

              <section className="mb-8">
                <div className="space-y-4 text-gray-600 dark:text-gray-400">
                  <p>
                    O Programa de Indicação do <em>the news</em> incentiva os leitores, já inscritos na newsletter, 
                    a convidarem outras pessoas a se tornarem leitores do <em>the news</em>.
                  </p>
                  
                  <p>
                    As regras do Programa de Indicação (as "Regras") aplicam-se exclusivamente aos programas administrados pelo <em>the news</em>.
                  </p>
                  
                  <p>
                    Ao compartilhar ou se cadastrar por meio de um link de indicação, você aceita e concorda integralmente com essas Regras. 
                    O descumprimento das Regras pode levar a penalidades, como exclusão de futuros Programas de Indicação, perda de prêmios 
                    conquistados e, em casos graves, o cancelamento da sua inscrição no <em>the news</em>.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-bold mb-4">Como Funciona?</h2>
                <div className="space-y-4 text-gray-600 dark:text-gray-400">
                  <p>
                    A cada indicação, o participante (o "Indicador") acumula pontos. Esses pontos podem ser trocados 
                    por prêmios, conforme o número de indicações realizadas.
                  </p>
                  
                  <p>Para que o cadastro seja realizado corretamente e os pontos sejam garantidos, alguns passos devem ser seguidos:</p>
                  
                  <ul className="list-disc pl-6 space-y-2">
                    <li>O Indicador deve compartilhar seu link de indicação único com outras pessoas, que devem ser novos leitores não cadastrados no <em>the news</em> (os "Indicados");</li>
                    <li>Para se registrarem, os Indicados devem utilizar o link de indicação único durante o processo de cadastro.</li>
                    <li>A indicação será considerada válida apenas quando o Indicado confirmar sua inscrição no <em>the news</em> através do e-mail de confirmação enviado automaticamente. O ponto será contabilizado somente após essa confirmação.</li>
                    <li>O Indicador pode acompanhar o progresso de suas indicações na aba "Indicações", seção "Visão Geral de Indicações";</li>
                    <li>O Indicador poderá resgatar os prêmios assim que acumular a quantidade de indicações necessárias para cada item disponível.</li>
                  </ul>

                  <p>
                    O <em>the news</em> não se responsabiliza por eventuais problemas no recebimento ou localização do e-mail de aprovação 
                    e confirmação do prêmio, incluindo casos em que o e-mail seja direcionado para a caixa de spam, outras abas ou pastas 
                    secundárias do serviço de e-mail utilizado pelo indicado. O resgate do prêmio deverá ser realizado em até 3 (três) 
                    meses após a notificação enviada através do e-mail de aprovação e confirmação.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-bold mb-4">Práticas Fraudulentas</h2>
                <div className="space-y-4 text-gray-600 dark:text-gray-400">
                  <p>
                    <strong>Importante: O <em>the news</em> reserva-se o direito de invalidar indicações provenientes de e-mails falsos 
                    ou de quaisquer práticas consideradas fraudulentas, conforme análise.</strong>
                  </p>
                  
                  <p>Indicações fraudulentas incluem, mas não se limitam a:</p>
                  
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Uso de e-mails descartáveis ou temporários que não correspondem a identidades reais;</li>
                    <li>Múltiplas entradas do mesmo usuário usando um único ou diferentes endereços IP comprometendo a integridade da plataforma;</li>
                    <li>E-mails criados exclusivamente para fins promocionais, com o único objetivo de manipular o sistema;</li>
                    <li>Exploração de vulnerabilidades técnicas no sistema de cadastro para manipular ou inserir informações de forma fraudulenta;</li>
                    <li>Uso de Inteligência Artificial para criação de múltiplas identidades para realizar ações repetitivas de forma fraudulenta, como a criação de e-mails, cadastros ou interações em massa e manipular resultados;</li>
                    <li>Quaisquer tentativas de contornar as Regras por meio de múltiplas identidades ou dispositivos.</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-bold mb-4">Premiação</h2>
                <div className="space-y-4 text-gray-600 dark:text-gray-400">
                  <p>Os prêmios oferecidos no programa estão sujeitas às seguintes condições:</p>
                  
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Podem ser alterados, substituídos ou descontinuados a critério do <em>the news</em>, mediante comunicação prévia;</li>
                    <li>Os prêmios serão entregues com base nas regras e condições aplicáveis ao programa de indicações no momento em que o resgate for solicitado;</li>
                    <li>Não possuem valor monetário, sendo intransferíveis e impossíveis de converter em dinheiro ou outros benefícios;</li>
                    <li>O Indicador está sujeito a verificações adicionais antes da entrega, incluindo a comprovação de elegibilidade e autenticidade das indicações.</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-bold mb-4">Validação das Indicações</h2>
                <div className="space-y-4 text-gray-600 dark:text-gray-400">
                  <p>
                    Cada indicação validada gera um ponto para o Indicador. Para que a indicação seja validada, a pessoa indicada deve confirmar 
                    a inscrição no <em>the news</em> por meio do e-mail de confirmação enviado automaticamente. O ponto será contabilizado 
                    apenas após essa confirmação.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-bold mb-4">Acumulação de Pontos</h2>
                <div className="space-y-4 text-gray-600 dark:text-gray-400">
                  <p>
                    Os pontos são cumulativos e, à medida que vão aumentando, novos prêmios são desbloqueados.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-bold mb-4">Rescisão e alterações</h2>
                <div className="space-y-4 text-gray-600 dark:text-gray-400">
                  <p>
                    O <em>the news</em> se reserva o direito de alterar, encerrar ou pausar, parcial ou integralmente, qualquer Programa 
                    de Indicação, os critérios de participação do Programa de Indicação ou de receber prêmios por Indicação por qualquer 
                    motivo, inclusive suspeita de fraude (tanto da pessoa que fez a indicação quanto da pessoa que a recebeu), abusou ou 
                    violação de qualquer das Regras.
                  </p>
                  
                  <p>
                    Caso o <em>the news</em> opte por encerrar o Programa de Indicação, os prêmios não resgatados poderão ser perdidos, 
                    desde que tenhamos enviado uma notificação previa para que o Indicador realize o resgate.
                  </p>
                  
                  <p>
                    O <em>the news</em> pode atualizar estas Regras a qualquer momento. As alterações entrarão em vigor quando o <em>the news</em> 
                    publicar a versão atualização no site. Ao continuar participando do Programa de Indicação após a atualização, o Indicador 
                    ou os Indicados manifestam sua concordância com a atualização.
                  </p>
                </div>
              </section>

            </div>

            <div className="flex justify-between items-center pt-6 border-t border-gray-200 dark:border-gray-700">
              <Link
                to="/"
                className="text-yellow-400 hover:text-yellow-500 transition-colors"
              >
                ← voltar
              </Link>
              <span className="text-sm text-gray-500 dark:text-gray-400">
                Última atualização: 28/01/2025
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};